<!-- PAGE CONTENT WRAPPER -->
<div class="page-content-wrap contentdata">
  <div class="row">
    <div class="col-md-12">
      <div class="page-breadcrumb"><!-- new -->
        <ul class="page-breadcrumb__trail">
          <li><a>Manage</a></li>
          <li><a>Pond Cultures</a></li>
        </ul>
        <div class="page-breadcrumb__icons">
          <a routerLink="/home"><img src="assets/images/New_Icons/home-transprent-icon.svg" title="Home"
              alt="Home icon"></a>
        </div>
      </div>
      <div class="block">
        <div class="page-header">
          <span class="page-header__title">Pond Cultures</span>
          <img src="assets/images/New_Icons/refresh-icon.svg" alt="Refresh icon" title="Refresh"
            class="page-header__icon" width="17" height="17" (click)="!enableDisablePageLoader ? ngOnInit() : null" />
        </div>
        <div class="list_block">
          <div class="toolbar">
            <div class="toolbar__search">
              <img src="../../../../../../assets/images/New_Icons/search-icon.svg" alt="Search icon">
              <input type="text" (ngModelChange)="onSearchChanged()" [(ngModel)]="search" name="search"
                autocomplete="off" placeholder="Search by pond culture identifier" />
            </div>
            <div class="toolbar__spacer"></div>
            <div class="toolbar__add-button" (click)="openForm()">
              <button type="button">
                <span class="toolbar__add-icon">
                  <img src="../../../../../../assets/images/New_Icons/plus-icon.svg" alt="Add Icon" />
                </span>
                <span class="toolbar__add-text">Add New</span>
              </button>
            </div>
          </div>
        </div>
        <div *ngIf="enableDisablePageLoader">
          <div class="adjust">
            <div class="loader2"></div>
          </div>
        </div>
        <div class="cards_container" *ngIf="!enableDisablePageLoader">
          <div class="card_wrapper" *ngFor="let poncCulture of pondCultures; let i = index">
            <div class="master-card">
              <div class="master-card-header">
                <div class="master-card-title">
                  <img src="../../../../../../assets/images/New_Icons/card-heading.svg" alt="Left arrow icon">
                  <span>{{ poncCulture.culture_identifier }}</span>
                </div>
              </div>
              <div class="master-card-body">
                <div class="master-card-body-info">
                  <span class="card-content-text">Pond:</span>
                  <span class="text">{{ poncCulture?.pond?.name }}</span>
                </div>
                <div class="master-card-body-info">
                  <span class="card-content-text">Culture:</span>
                  <span class="text">{{ poncCulture?.cultureCategory?.name }}</span>
                </div>
                <div class="master-card-body-info">
                  <span class="card-content-text">Species:</span>
                  <span class="text">{{ poncCulture?.speciesType?.name }}</span>
                </div>
                <div class="master-card-body-info">
                  <span class="card-content-text">Water Type:</span>
                  <span class="text">{{ poncCulture?.waterType?.name }}</span>
                </div>
                <div class="master-card-body-info">
                  <span class="card-content-text">Soil Type:</span>
                  <span class="text">{{ poncCulture?.soilType?.name }}</span>
                </div>
                <div class="master-card-body-info">
                  <span class="card-content-text">Stocking Count:</span>
                  <span class="text">{{ poncCulture?.stocking_count }}</span>
                </div>
                <div class="master-card-body-info">
                  <span class="card-content-text">Date of Stocking:</span>
                  <span class="text">{{ poncCulture?.date_of_stocking | date: "dd MMM yyyy"}}</span>
                </div>
                  <div class="master-card-body-info">
                  <span class="card-content-text">Time of Stocking:</span>
                  <span class="text">{{ poncCulture?.time_of_stocking }}</span>
                </div>
                <div class="master-card-body-info">
                  <span class="card-content-text">Start Date:</span>
                  <span class="text">{{ poncCulture?.start_date | date: "dd MMM yyyy" }}</span>
                </div>
                 <div class="master-card-body-info">
                  <span class="card-content-text">End Date:</span>
                  <span class="text">{{ poncCulture?.end_date ? (poncCulture?.end_date | date: "dd MMM yyyy") : 'NA' }}</span>
                </div>
              </div>
              <div class="master-card-footer">
                <div class="master-card-footer-info">
                  <span class="label">Created At:</span>
                  <span class="text">{{ poncCulture?.createdAt | date: "dd MMM yyyy" }}</span>
                </div>
                <div class="action-icons">

                </div>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="listLoader" class="loader-div">
          <div class="adjust">
            <div class="loader2 list-loader"></div>
          </div>
        </div>
        <div *ngIf="noList && !enableDisablePageLoader" class="noDataFoundMessage">Pond Cultures Not Found</div>
        <!--sensor types block end-->
      </div>
      <!--add/update form-->
      <div class="dynamic-form-wrapper"
        [ngClass]="{ 'floating-panel': formFieldCount <= 7, 'slide-in-overlay': formFieldCount > 7}" *ngIf="showForm">
        <!--<div *ngIf="formFieldCount > 7" class="overlay-background" (click)="closeForm()"></div>-->
        <!--outside close-->
        <div class="popup-wrapper">
          <button type="button" class="popup-close-beside" (click)="clear()" title="Close">&times;</button>
          <!-- Actual Popup -->
          <div [ngClass]="{ 'form-container-panel': formFieldCount > 7, 'popup-inner': formFieldCount <= 7}">
            <form [formGroup]="registerForm" novalidate>
              <div class="form-header">
                <div class="form-title">Pond Culture</div>
                <button class="add-update-submit-button" (click)="addUpdatePondCulture()"
                  [disabled]="sensorDoubleClick">
                  <span class="icon"><img src="../../../../../../assets/images/New_Icons/tick-icon.svg"
                      alt="Tick icon"></span>
                  <span class="text">Submit</span>
                </button>
              </div>
              <div class="form-container">
                <div class="form-section">
                  <h3 class="section-title">Pond Details</h3>
                  <div class="grid-three-cols">
                    <!--Pond-->
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>Pond</mat-label>
                      <mat-select id="pond" formControlName="pond_id">
                        <mat-option value="" disabled>Select Pond</mat-option>
                        <mat-option *ngFor="let pond of ponds" [value]="pond.id"> {{ pond.name }} </mat-option>
                      </mat-select>
                      <mat-hint *ngIf="f.pond_id.invalid"><i>Select Pond</i></mat-hint>
                      <mat-hint *ngIf="f.pond_id.valid"><i>Pond Selected</i></mat-hint>
                      <mat-error
                        *ngIf="(f.pond_id.touched || f.pond_id.dirty || submitted) && f.pond_id.hasError('required')">
                        <i>Required.</i>
                      </mat-error>
                    </mat-form-field>
                    <!--  Culture Category -->
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>Culture Category</mat-label>
                      <mat-select id="cultureCategory" formControlName="culture_category_id"
                        (selectionChange)="getSpeciesByCultureCategory()">
                        <mat-option value="" disabled>Select Culture</mat-option>
                        <mat-option *ngFor="let cultureCategory of cultureCategories" [value]="cultureCategory.id"> {{
                          cultureCategory.name }} </mat-option>
                      </mat-select>
                      <mat-hint *ngIf="f.culture_category_id.invalid"><i>Select Culture Category</i></mat-hint>
                      <mat-hint *ngIf="f.culture_category_id.valid"><i>Culture Category Selected</i></mat-hint>
                      <mat-error
                        *ngIf="(f.culture_category_id.touched || f.culture_category_id.dirty || submitted) && f.culture_category_id.hasError('required')">
                        <i>Required.</i>
                      </mat-error>
                    </mat-form-field>
                    <!--  Species Type -->
                    <mat-form-field appearance="outline" class="w-100" *ngIf="registerForm.value.culture_category_id">
                      <mat-label>Species Type</mat-label>
                      <mat-select id="species" formControlName="species_type_id">
                        <mat-option value="" disabled>Select Species</mat-option>
                        <mat-option *ngFor="let speciesType of filTeredSpeciesTypes" [value]="speciesType.id"> {{
                          speciesType.name }} </mat-option>
                      </mat-select>
                      <mat-hint *ngIf="f.species_type_id.invalid"><i>Select Species</i></mat-hint>
                      <mat-hint *ngIf="f.species_type_id.valid"><i>Species Selected</i></mat-hint>
                      <mat-error
                        *ngIf="(f.species_type_id.touched || f.species_type_id.dirty || submitted) && f.species_type_id.hasError('required')">
                        <i>Required.</i>
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>
                <div class="form-section">
                  <div class="grid-three-cols">
                    <!--  Culture Type -->
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>Culture Type</mat-label>
                      <mat-select id="cultureType" formControlName="culture_type_id">
                        <mat-option value="" disabled>Select Culture Type</mat-option>
                        <mat-option *ngFor="let cultureType of cultureTypes" [value]="cultureType.id"> {{
                          cultureType.name }} </mat-option>
                      </mat-select>
                      <mat-hint *ngIf="f.culture_type_id.invalid"><i>Select Culture Type</i></mat-hint>
                      <mat-hint *ngIf="f.culture_type_id.valid"><i>Culture Type Selected</i></mat-hint>
                      <mat-error
                        *ngIf="(f.culture_type_id.touched || f.culture_type_id.dirty || submitted) && f.culture_type_id.hasError('required')">
                        <i>Required.</i>
                      </mat-error>
                    </mat-form-field>
                    <!--Water Type-->
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>Water Type</mat-label>
                      <mat-select id="waterType" formControlName="water_type_id">
                        <mat-option value="" disabled>Select Water Type</mat-option>
                        <mat-option *ngFor="let waterType of waterTypes" [value]="waterType.id"> {{ waterType.name }}
                        </mat-option>
                      </mat-select>
                      <mat-hint *ngIf="f.water_type_id.invalid"><i>Select Water Type</i></mat-hint>
                      <mat-hint *ngIf="f.water_type_id.valid"><i>Water Type Selected</i></mat-hint>
                      <mat-error
                        *ngIf="(f.water_type_id.touched || f.water_type_id.dirty || submitted) && f.water_type_id.hasError('required')">
                        <i>Required.</i>
                      </mat-error>
                    </mat-form-field>
                    <!--Soil Type-->
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>Soil Type</mat-label>
                      <mat-select id="soilType" formControlName="soil_type_id">
                        <mat-option value="" disabled>Select Soil Type</mat-option>
                        <mat-option *ngFor="let soilType of soilTypes" [value]="soilType.id"> {{ soilType.name }}
                        </mat-option>
                      </mat-select>
                      <mat-hint *ngIf="f.soil_type_id.invalid"><i>Select Soil Type</i></mat-hint>
                      <mat-hint *ngIf="f.soil_type_id.valid"><i>Soil Type Selected</i></mat-hint>
                      <mat-error
                        *ngIf="(f.soil_type_id.touched || f.soil_type_id.dirty || submitted) && f.soil_type_id.hasError('required')">
                        <i>Required.</i>
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>
                <div class="form-section">
                  <h3 class="section-title">Stocking Details</h3>
                  <div class="grid-three-cols">
                    <!--Stocking Count-->
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>Stocking Count</mat-label>
                      <input matInput id="stockingcount" formControlName="stocking_count" autocomplete="off"
                        placeholder="Stocking count" />
                      <mat-error
                        *ngIf="(submitted || f.stocking_count.touched || f.stocking_count.dirty) && f.stocking_count.hasError('pattern')">
                        <i>Invalid value.</i>
                      </mat-error>
                    </mat-form-field>
                    <!--Stocking Density-->
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>Stocking Density</mat-label>
                      <input matInput id="stockingdensity" formControlName="stocking_density" autocomplete="off"
                        placeholder="Stocking density" />
                      <mat-error
                        *ngIf="(submitted || f.stocking_density.touched || f.stocking_density.dirty) && f.stocking_density.hasError('pattern')">
                        <i>Invalid value.</i>
                      </mat-error>
                    </mat-form-field>
                    <!--Stocking Date-->
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>Stocking Date</mat-label>
                      <input matInput [matDatepicker]="frompicker" placeholder="Choose date" autocomplete="off" readonly
                        [max]="maxDate" formControlName="date_of_stocking" />
                      <mat-datepicker-toggle matSuffix [for]="frompicker"></mat-datepicker-toggle>
                      <mat-datepicker #frompicker></mat-datepicker>
                    </mat-form-field>
                    <!--Stocking Time-->
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>Stocking Time</mat-label>
                      <input matInput [ngxTimepicker]="picker" [format]="24" placeholder="Select time"
                        (click)="picker.open()" readonly formControlName="time_of_stocking">

                      <ngx-material-timepicker #picker [defaultTime]="'08:00'">
                      </ngx-material-timepicker>
                    </mat-form-field>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      <!--add/update form end-->
    </div>
  </div>
</div>